import * as moment from "moment";
import {AccountingCommonUpdatedEventDataApiDto, BillEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import BillEvent, {BillEventTypeEnum} from "./BillEvent";
import {AccountingCommonUpdatedEventData} from "../../invoice/event/InvoiceUpdatedEvent";

/**
 * Bill updated event model.
 */
export default class BillUpdatedEvent extends BillEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {InvoiceEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 * @param {AccountingCommonUpdatedEventData} data bill updated event data.
	 */
	constructor(public readonly id: string,
		public readonly type: BillEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment,
		public readonly data: AccountingCommonUpdatedEventData) {
		super(id, type, creator, creationDateTime);
	}

	public static fromJson(json: BillEventApiDto): BillUpdatedEvent {
		const data = AccountingCommonUpdatedEventData.fromJson(json.data as AccountingCommonUpdatedEventDataApiDto);
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new BillUpdatedEvent(json.id, BillEventTypeEnum.BillUpdated, creator, moment(json.creationDateTime), data);
	}

	getIcon() {
		return Icon.Status;
	}

	getActivityType(): string {
		return `BILL UPDATED`;
	}

	getActivityMessage(): string {
		return `Bill updated`
	}
}
